import { createResourceStore } from "@/lib/resource";
import type { FinanceAccount } from "./FinanceAccount";

import type { FinanceCategory } from "./FinanceCategory";

import type { User } from "./User";

export interface FinanceTransaction {
  id: string;
  debit: number;
  credit: number;
  finance_account_id: string;
  payable_id?: string | null;
  payable_type?: string;
  description?: string | null;
  status: "pending" | "approved" | "completed" | "cancelled";
  payment_method?: string | null;
  user_id: string | null;
  category_id: string | null;
  meta: Record<string, any>;
  account: FinanceAccount;
  user: User;
  creator: User;
  updater: User;
  category: FinanceCategory;
  payable: any;
  created_at: string;
  updated_at: string;
  categoryName: string;
  reference: {
    type: string | null | undefined;
    name: string | null | undefined;
  };
}

export const useFinanceTransaction = createResourceStore<FinanceTransaction>(
  "finance-transactions",
  () => ({
    stats: {
      filters: {
        start_date: "",
        end_date: "",
      },
      series: {
        labels: [
          "Jan 2025",
          "Feb 2025",
          "Mar 2025",
          "Apr 2025",
          "May 2025",
          "Jun 2025",
          "Jul 2025",
          "Aug 2025",
          "Sep 2025",
          "Oct 2025",
          "Nov 2025",
          "Dec 2025",
        ],
        datasets: [
          {
            label: "Income",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            color: "#10b981",
          },
          {
            label: "Expense",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            color: "#ef4444",
          },
        ],
      },
      accounts: [],
      top_income_categories: [],
      top_expense_categories: [],

      total_incomes: 0.0,
      total_expenses: 0.0,
      net_profit: 0.0,
      total_balance: 0.0,
      completed_incomes: 0.0,
      completed_expenses: 0.0,
      top_income_accounts: [],
      top_expense_accounts: [],
    },

    transform: (item: FinanceTransaction) => {
      return {
        ...item,
        payable_type: item.payable_type?.split("\\").pop(),
      };
    },
  })
);
